<div class="reservation-details h100 w100">
  <div class="reservation-details__configuration">
    <!-- <ng-scrollbar> -->
      <div [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentTopBackgroundColor}">


      <div class="reservation-details__available-data">
        <!-- Need to change the styles based on Merchant portal -->
        <div for="" class="reservation-details__title page-title" [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderBackgroundColor,
                                  'font-size': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderFontSize+'px',
                                  'text-align': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderPosition,
                                  'font-family': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderFont,
                                  'color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
          *ngIf="ls.operation==operationType.create">
          <span
            *ngIf="ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderText">{{ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderText}}</span>
          <span
            *ngIf="!ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderText">{{'letsMakeReservation' | translate}}</span>
        </div>
        <div class="reservation-details__event-selection" *ngIf="!ls.restaurantWidgetSettings$.value.WidgetCustomization.AllowNewReservations && specialMealList.length && ls.operation != operationType.edit">
          <dynamic-form [config]="reservationSelectionConfig" #reservationSelectionForm="dynamicForm">
          </dynamic-form>
        </div>
        <div class="reservation-details__special-meal"
          *ngIf="isSpecialMealAvailable && specialMealList.length > 0 && ls.operation==operationType.create">
          <div class="reservation-details__special-meal-header">
            <span for="" class="default-sub-header">{{'availableMenu' | translate}}</span>
            <span for="" class="default-sub-header reservation-details__prepayment-legend" *ngIf="showPrepaymentIcon()">
              <span class="icon-payments_FILL0_wght400_GRAD0_opsz48-1"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span
                  class="path4"></span></span>
              {{'prePaymentNeeded' | translate}}</span>
          </div>
          <!-- Need to change the styles based on Merchant portal -->
          <div class="reservation-details__special-meal-row" *ngIf="ls.operation==operationType.create" [ngStyle]="{'font-family': ls.restaurantWidgetSettings$.value.WidgetCustomization.SpecialMealFont,
                              'font-size': ls.restaurantWidgetSettings$.value.WidgetCustomization.SpecialMealFontSize+'px'}">
            <div class="reservation-details__special-meal-data selectable-data-bg"
              [ngStyle]="{'background-color':(specialMeal.Id == selectedMeal.Id ? (ls.restaurantWidgetSettings$.value.WidgetCustomization.SMSelectedBackgroundColor ? ls.restaurantWidgetSettings$.value.WidgetCustomization.SMSelectedBackgroundColor : '#D9D9D9'): ls.restaurantWidgetSettings$.value.WidgetCustomization.SMBackgroundColor)}"
              [ngClass]="{'no-cursor': specialMeal.Id == selectedMeal.Id}" (click)="selectedSpecialMeal(specialMeal)"
              *ngFor="let specialMeal of specialMealList">
              <span class="icon-payments_FILL0_wght400_GRAD0_opsz48-1 reservation-details__prepayment-icon" *ngIf="specialMeal.DoesRequirePrepayment">
                <span class="path1"></span><span class="path2"></span><span class="path3"></span><span
                  class="path4"></span></span>
              <div class="default-sub-header reservation-details__special-meal-name"
                [ngClass]="{'focused-sub-header':specialMeal.Id == selectedMeal.Id}"
                [ngStyle]="{'font-size': ls.restaurantWidgetSettings$.value.WidgetCustomization.SpecialMealFontSize+'px'}">
                {{specialMeal.Name}}</div>
              <div class="helper-text reservation-details__special-meal-serves">
                {{'serves'| translate}}
                {{specialMeal.MinPartySize}} -
                {{specialMeal.MaxPartySize}}
                {{'people' | translate}}
              </div>
              <div class="helper-text-small" [ngClass]="{'view-price-cursor': specialMeal.Id == selectedMeal.Id}">
                <span *ngIf="specialMeal.CoverTypePrices?.length > 0"
                  [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.WidgetLinkColor}"
                  placement="bottom-left" (click)="selectedViewPricing(specialMeal)"
                  (shown)="availableCoverTypePrices.length > 0" [ngbPopover]="popContent">{{'viewPrice' |
                  translate}}</span>
                <span *ngIf="specialMeal.CoverTypePrices?.length == 0"
                  class="reservation-details__price-data">{{specialMeal.Price ?  (ls.OperationCurrency) + (specialMeal.Price | currencyDecimalFormatter) : ''}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class=" content-summary" *ngIf="ls.operation==operationType.edit">
        <div class="page-title" style="padding-bottom: 10px;">{{'reservationSummary'| translate}}</div>
        <div class="reservation-details__reservation-data">
          <span class="reservation-details__guest-info-text"
            *ngIf="ls.editPartyData$.value.SpecialMeal && ls.editPartyData$.value.SpecialMeal.Name">{{ls.editPartyData$.value.SpecialMeal.Name}}
            <span
              *ngIf="ls.editPartyData$.value.SpecialMealAmount >0 && ls.editPartyData$.value.PrepaymentState != PartyPrepaymentState.Refunded">-
              {{ls.restaurantWidgetSettings$.value.OperationCurrency}}{{ls.editPartyData$.value.SpecialMealAmount | currencyDecimalFormatter}}</span>
          </span>
          <span class="reservation-details__guest-info-text">{{ls.editPartyData$.value.Size}} {{'party' | translate}}</span>
          <span class="reservation-details__guest-info-text">{{ls.editPartyData$.value.ReservedFor |
            formatSettingsDate : ls.restaurantWidgetSettings$.value.DateFormat}}</span>
          <span class="reservation-details__guest-info-text">{{ls.editPartyData$.value.ReservedFor| localizeDate:'h:mm A'}}</span>
          <span class="reservation-details__guest-info-text"
            *ngIf="ls.editPartyData$.value.SeatingTypeId > 0">{{ls.editPartyData$.value.SeatingTypeId | seatingTypeFilter :
            ls.restaurantWidgetSettings$.value.SeatingTypeList}}
            <span
              *ngIf="ls.editPartyData$.value.RatePlanAmount > 0 && ls.editPartyData$.value.PrepaymentState != PartyPrepaymentState.Refunded">-
              {{ls.restaurantWidgetSettings$.value.OperationCurrency}}{{ls.editPartyData$.value.RatePlanAmount | currencyDecimalFormatter}}</span>
          </span>
          <!--<span *ngIf="paymentData && paymentData.RateplanAmountinfo && paymentData.RateplanAmountinfo >0">-
                              {{paymentData.OperationCurrency}}{{paymentData.RateplanAmountinfo | currencyDecimalFormatter}}</span>
                          </span> -->
          <span class="rereservation-details__guest-info-text"
            *ngIf="ls.editPartyData$.value.NoShowFeeAmount>0 && ls.editPartyData$.value.PrepaymentState == PartyPrepaymentState.None">
            {{'amount' |
            translate}}{{ls.restaurantWidgetSettings$.value.OperationCurrency}}{{ls.editPartyData$.value.NoShowFeeAmount | currencyDecimalFormatter}}</span>
          <!-- <div style="padding: 0 12px;">
                          <app-button [buttontype]="editButton" (valueChange)="goBackToReservation()"></app-button>
                        </div> -->
        </div>
      </div>
      <!-- Need to change the styles based on Merchant portal -->
      <div class="page-title" style="padding-top: 20px;"
      [ngStyle]="{'font-size': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderFontSize+'px',
      'text-align': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderPosition,
      'font-family': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderFont}" *ngIf="ls.operation==operationType.edit">{{'modifyReservation' | translate}}</div>
      <div class="reservation-details__party-size-section">
        <a class="reservation-details__availability-text pl-4" (click)="availabilityText == 'refresh' ? onRefreshClick() : showOtherDaysAvailable()" style="" *ngIf="showOtherDays && showRefreshText">
          <em class="icon-Refresh reservation-details__refresh-icon"  [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.WidgetLinkColor}" style=""  (click)="onRefreshClick()"></em>
          <span class="focused-sub-header"  [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.WidgetLinkColor}">{{availabilityText | translate}}</span>
        </a>
        <dynamic-form [config]="reservationConfig" #reservationConfigForm="dynamicForm">
        </dynamic-form>

      </div>
      <div class="reservation-details__cover-type-section" [ngClass]="{'reservation-details__covers-no-padding': coverTypeConfig.length == 0 }">
        <!-- <div *ngIf="coverTypeConfig.length > 0" class="default-sub-header reservation-details__cover-type-title">
          {{'coverType' |
          translate}}</div> -->
          <mat-error
            *ngIf="partySizeError">
            *{{partySizeError}}
          </mat-error>
        <dynamic-form [config]="coverTypeConfig" #coverTypeForm="dynamicForm">
        </dynamic-form>
      </div>
      <!--Needed for show availability on other days -->
      <div class="reservation-details__availability-days">
        <a class="reservation-details__availability-text" (click)="availabilityText == 'refresh' ? onRefreshClick() : showOtherDaysAvailable()" *ngIf="!showOtherDays && !showRefreshText && showSlots">
          <span class="focused-sub-header"  [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.WidgetLinkColor}">{{availabilityText | translate}}</span>
        </a>
        <div class="reservation-details__available-content" *ngIf="showOtherDays">
          <span role="button" aria-pressed="false" *ngIf="otherAvailableDays.length > 5" (click)="navigateLeft()" class="icon-Left-Arrow"></span>
          <div #availableDateContainer class="reservation-details__days-view">

            <div (click)="selectedDate(days)" class="reservation-details__date-view"
              [ngClass]="{'reservation-details__selected':(selectedDay && days.Id == selectedDay.Id)}" *ngFor="let days of otherAvailableDays">
              <span>{{days.value | localizeDate: 'DD'}}</span>
              <span>{{days.value | localizeDate: 'dddd'}}</span>
            </div>
          </div>
          <span role="button" aria-pressed="false" *ngIf="otherAvailableDays.length > 5" (click)="navigateRight()" class="icon-Right-Arrow"></span>
        </div>
      </div>
    </div>
      <div class="reservation-details__check-availability-btn" *ngIf="availableMealPeriods.length == 0 && !showSlots">
        <app-button [buttontype]="CheckAvailabilityBtn" (valueChange)="CheckAvailability($event)"></app-button>
      </div>
      <div id="timeBtnGroup" class="reservation-details__available-time" *ngIf="showSlots && !isDropdown" [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentBottomBackgroundColor}">
        <span for="" class="default-sub-header reservation-details__time-title">{{'time' | translate}}</span>

          <div class="reservation-details__btn-row" *ngIf="timeBtnArray.length > 0 && ls.isMobileBrowser">
            <swiper [config]="config">
              <div *ngFor="let timeBtn of timeBtnArray" style="display: inline-block;">
                <app-button id="btn-{{timeBtn.Id}}"
                  [buttontype]="timeBtn.Value | localizeDate: 'LT' | buttonInputFormater : buttonType.optionBtn :'btn-section default-form-field':false"
                  (click)="selectedTimeArray(timeBtn)"></app-button>
              </div>
            </swiper>
          </div>
          <div class="reservation-details__btn-row-desktop" *ngIf="timeBtnArray.length > 0 && !ls.isMobileBrowser">
            <app-button id="btn-{{timeBtn.Id}}" *ngFor="let timeBtn of timeBtnArray"
            [buttontype]="timeBtn.Value | localizeDate: 'LT' | buttonInputFormater : buttonType.optionBtn :'btn-section default-form-field':false"
            (click)="selectedTimeArray(timeBtn)"></app-button>
          </div>
          <div class="reservation-details__no-time-available default-form-field selectable-data-bg"
            *ngIf="timeBtnArray.length == 0">
            {{'noSlotsAvailable' | translate}}
          </div>

      </div>
      <div id="timeDropDownGroup" class="reservation-details__available-select-time" *ngIf="showSlots && isDropdown" [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentBottomBackgroundColor}">
        <div class="reservation-details__time-selection" *ngIf="timeBtnArray.length > 0">
          <dynamic-form [config]="timeBtnArrayConfig" #timeConfigForm="dynamicForm">
          </dynamic-form>
        </div>
        <div class="reservation-details__no-time-available default-form-field selectable-data-bg"
          *ngIf="timeBtnArray.length == 0">
          {{'noSlotsAvailable' | translate}}
        </div>
      </div>
    <!-- </ng-scrollbar> -->
  </div>
  <div class="reservation-details__actions" *ngIf="timeBtnArray.length > 0 && showSlots">
    <!-- <app-button [buttontype]="previousButton"></app-button> -->
    <app-button [buttontype]="nextButton" (valueChange)="getSeatSelection()"></app-button>
  </div>
  <ng-template #popContent>
    <div class="reservation-details__cover-type-popover">
      <div class="reservation-details__cover-type-data toast-message"
        *ngFor="let coverType of availableCoverTypePrices;let i =index;let lastItem = last">
        <div class="reservation-details__cover-type-name">{{coverType.CoverTypeName}}</div>
        <div>{{ls.restaurantWidgetSettings$.value.OperationCurrency}} {{coverType.Price | currencyDecimalFormatter}}</div>
      </div>
    </div>
  </ng-template>
</div>
